import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {catchError, retry} from 'rxjs/operators';
import {HttpErrorHandler} from '../../http.error.handler';
import {DriverWithShiftCount} from '../../shared/models/driver.model';
import {JsonApiResponse} from '../../shared/models/JsonApiResponse';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DriversService {

  constructor(private http: HttpClient) {
  }

  getDriverList(from: Date = null, to: Date = null) {
    let params = new HttpParams();
    if (from) {
      params = params.set('shiftStartedFrom', from.toISOString());
    }
    if (to) {
      params = params.set('shiftEndedTo', to.toISOString());
    }
    return firstValueFrom(
      this.http
        .get<JsonApiResponse<DriverWithShiftCount[]>>(`${environment.services.service}v1/driver/all`, {params})
        .pipe(
          retry(3), // retry a failed request up to 3 times
          catchError(HttpErrorHandler.handleError) // then handle the error
        )
    );
  }

}
